import { ExportTypeEnum } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { CodeBookExtended, EditCodeBookRequest } from "../../models/CodeBook";

const languageLevelUrlPrefix: string = "language-levels";

export const getLanguageLevels = async () => {
  let result = await api.get(
    `${languageLevelUrlPrefix}/detail`
  ) as CodeBookExtended[];
  setDatesLanguageLevels(result);
  return result;
}

export const getLanguageLevelById = async (id: number) => {
  let result = await api.get(
      `${languageLevelUrlPrefix}/${id}`
  ) as CodeBookExtended;
  setDatesLanguageLevel(result);
  return result
}

export const createLanguageLevel = async (request: EditCodeBookRequest) => {
  return api.post(
      `${languageLevelUrlPrefix}`,
      request
  ) as Promise<number>
}

export const editLanguageLevel = async (id: number, request: EditCodeBookRequest) => {
  return api.put(
      `${languageLevelUrlPrefix}/${id}`,
      request
  ) as Promise<void>
}

export const deleteLanguageLevel = async (id: number) => {
  return api.delete(
      `${languageLevelUrlPrefix}/${id}`
  ) as Promise<void>
}

export const exportLanguageLevels = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${languageLevelUrlPrefix}/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}


const setDatesLanguageLevels = (items: CodeBookExtended[]) => {
  for (let item of items) {
    setDatesLanguageLevel(item);
  }
}

const setDatesLanguageLevel = (item: CodeBookExtended) => {
  if (item.dateTo) {
    item.dateTo = new Date(item.dateTo);
  }
}